// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1mKCy","errorLogs":"styles_errorLogs__VExLR"};